export default {
  "login": "sundayonah",
  "id": 82456387,
  "node_id": "MDQ6VXNlcjgyNDU2Mzg3",
  "avatar_url": "https://avatars.githubusercontent.com/u/82456387?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/sundayonah",
  "html_url": "https://github.com/sundayonah",
  "followers_url": "https://api.github.com/users/sundayonah/followers",
  "following_url": "https://api.github.com/users/sundayonah/following{/other_user}",
  "gists_url": "https://api.github.com/users/sundayonah/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/sundayonah/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/sundayonah/subscriptions",
  "organizations_url": "https://api.github.com/users/sundayonah/orgs",
  "repos_url": "https://api.github.com/users/sundayonah/repos",
  "events_url": "https://api.github.com/users/sundayonah/events{/privacy}",
  "received_events_url": "https://api.github.com/users/sundayonah/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Onah Sunday.",
  "company": null,
  "blog": "https://onahsunday.vercel.app/",
  "location": "Remote",
  "email": null,
  "hireable": true,
  "bio": "< Frontend | Web3 Integration/>",
  "twitter_username": "onah_sunday",
  "public_repos": 88,
  "public_gists": 0,
  "followers": 4,
  "following": 24,
  "created_at": "2021-04-13T13:43:36Z",
  "updated_at": "2024-10-02T07:06:10Z"
};
